import { dataFetcher, fileUploader } from 'core/services/requestHandler';   

const getNotificationList = async (data = {}, config = {}) => {
  return dataFetcher('GetNotificationList', data, {...config});
};

const sendNotifications = async (data = {}, config = {}) => {
  return fileUploader('notifications', data, {...config});
};

export { getNotificationList, sendNotifications };
